import _ from 'lodash'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	IPageDidMountHandler,
	IPropsStore,
	contextIdSymbol,
	PageFeatureConfigSymbol,
	Props,
	SiteFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import {
	TpaCommonsSiteConfig,
	ITpaSrcUtility,
	ITpaContextMapping,
	name as tpaCommonsName,
	TpaSrcUtilitySymbol,
	TpaContextMappingSymbol,
} from 'feature-tpa-commons'
import * as ResponsiveChatUtils from '../utils/responsiveChatUtils'
import type { ITpa, ITpaComponentApi, ITpaLoadMeasure, TpaPageConfig } from '../types'
import { name, TpaComponentApiSymbol, TpaLoadMeasureSymbol } from '../symbols'

export const TpaDs = withDependencies(
	[
		Props,
		named(SiteFeatureConfigSymbol, tpaCommonsName),
		named(PageFeatureConfigSymbol, name),
		TpaLoadMeasureSymbol,
		TpaComponentApiSymbol,
		TpaSrcUtilitySymbol,
		contextIdSymbol,
		TpaContextMappingSymbol,
	],
	(
		props: IPropsStore,
		tpaCommonsSiteConfig: TpaCommonsSiteConfig,
		tpaPageConfig: TpaPageConfig,
		tpaLoadMeasure: ITpaLoadMeasure,
		tpaComponentApi: ITpaComponentApi,
		{ registerTpaControls }: ITpaSrcUtility,
		contextId: string,
		tpaContextMapping: ITpaContextMapping
	): ITpa & IPageDidMountHandler => {
		const { widgets, tpaInnerRouteConfig } = tpaPageConfig
		const tpaWidgetsToRegister = Object.entries(widgets)
			// Register ResponsiveChat under its template id, and not the viewer id
			.map(([id, tpaCompData]) => {
				const uniqueOrTemplateId = ResponsiveChatUtils.getTemplateOrUniqueId(id, tpaCompData)
				if (id !== uniqueOrTemplateId) {
					tpaContextMapping.registerTpaTemplateId(uniqueOrTemplateId, id)
				}
				return uniqueOrTemplateId
			})

		tpaContextMapping.registerTpasForContext({ contextId, pageId: tpaPageConfig.pageId }, tpaWidgetsToRegister)

		const rebuildTpaSrc = (compId: string) => {
			const src = tpaCommonsSiteConfig.shouldRenderTPAsIframe
				? tpaComponentApi.buildSrc({
						compId,
						tpaCompData: widgets[compId]!,
						pageId: tpaPageConfig.pageId,
						tpaInnerRouteConfig,
				  })
				: null
			tpaLoadMeasure.reportTpaLoadStart(compId, src)
			props.update({
				[compId]: {
					src,
				},
			})
		}

		const rebuildTpasSrc = () => {
			const tpas = _.pickBy(
				widgets,
				({ widgetId, isOOI }) => !isOOI && tpaCommonsSiteConfig.widgetsClientSpecMapData[widgetId]
			)
			Object.keys(tpas).forEach(rebuildTpaSrc)
		}

		registerTpaControls(contextId, {
			rebuildTpasSrc,
			rebuildTpaSrc,
		})

		return {
			pageDidMount() {
				// make feature part load in ds
			},
			rebuildTpasSrc,
			rebuildTpaSrc,
		}
	}
)
